import React from "react";
import { NavLink } from "react-router-dom";
import { getCustomUserAgent, getCustomUserAgentKrk } from "../../../customUserAgent";

import "../styles/Sidebar.css";
import {
  pathMain,
  pathContacts,
  pathNews,
  pathDemand,
  pathSchedule,
} from "../../../config/vars";
import { isIntfAccessDenied, keyIntfContacts, keyIntfDemands, keyIntfMap, keyIntfNews } from "../../../disabledInterfaces";
import { $SiteColors } from "../../../config/company-atts";

export const Sidebar = () => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const navRef = React.useRef<HTMLElement>(null);
  const buttonRef = React.useRef<HTMLDivElement>(null);

  const buttonClassName = `${openMenu ? "sidebar__button sidebar__button_active" : "sidebar__button"
    }`;
  const sidebarClassName = `${openMenu ? "sidebar sidebar_active" : "sidebar"}`;

  function openCloseMenu() {
    setOpenMenu(!openMenu);
  }

  function closeByRedirect() {
    setOpenMenu(false);
  }

  // Закрываем мобильное меню по клику вне меню и вне кнопки-гамбургера.
  React.useEffect(() => {
    if (!openMenu) return;
    const onDocMouseDown = (e: MouseEvent) => {
      const t = e.target as Node;
      if (
        navRef.current && !navRef.current.contains(t) &&
        buttonRef.current && !buttonRef.current.contains(t)
      ) {
        setOpenMenu(false);
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, [openMenu]);

  return (
    <>
      <div className="sidebar__button-container" ref={buttonRef}>
        <button className={buttonClassName} onClick={openCloseMenu} >
          <span></span>
        </button>
      </div>
      <nav ref={navRef} className={sidebarClassName} style={openMenu?{backgroundColor:"#fff"}:{}} >
        <NavLink
          exact
          to={pathMain}
          style={{color: openMenu ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Главная
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfNews)}
          to={pathNews}
          style={{color: openMenu ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Новости
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfDemands)}
          to={pathDemand}
          style={{color: openMenu ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Заявки
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfMap)}
          to={pathSchedule}
          style={{color: openMenu ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          График мусоровозов
        </NavLink>

        <NavLink
          hidden={isIntfAccessDenied(keyIntfContacts)}
          to={pathContacts}
          style={{color: openMenu ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Связаться с УК
        </NavLink>
      </nav>
    </>
  );
};
